import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Slider } from "./Slider/Slider";
import Spotlight from "./Spotlight/Spotlight";
import { TravellerEssentialsTab } from "./TravllerEssential/TravellerEssentialTab";
import UsefulTipsTab from "./UsefullTips/UsefulTipsTab";
import YouTubeTab from "./Youtube/YouTubeTab";

export const HomepageManagement: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const activeTab = query.get("activeTab");
  const subActiveTab = query.get("subActiveTab");

  useEffect(() => {
    if (query.get("id")) {
      return;
    }
    if (!activeTab) {
      navigate(`${window.location.pathname}?activeTab=sliders`, { replace: true });
      return;
    }

    if (activeTab === "spotlight" && !subActiveTab) {
      navigate(`${window.location.pathname}?activeTab=spotlight&subActiveTab=spotlightCards`, {
        replace: true,
      });
    } else if (activeTab === "travellerEssentials" && !subActiveTab) {
      navigate(`${window.location.pathname}?activeTab=travellerEssentials&subActiveTab=travellerEssentialsOverview`, {
        replace: true,
      });
    } else if (activeTab === "usefulTips" && !subActiveTab) {
      navigate(`${window.location.pathname}?activeTab=usefulTips&subActiveTab=usefulTipsPageContent`, {
        replace: true,
      });
    }
  }, [activeTab, subActiveTab, navigate]);

  const items = [
    { label: "Slider", key: "sliders", children: <Slider /> },
    {
      label: "Spotlight",
      key: "spotlight",
      children: <Spotlight />,
    },
    { label: "YouTube", key: "youtube", children: <YouTubeTab /> },
    { label: "Traveller Essentials", key: "travellerEssentials", children: <TravellerEssentialsTab /> },
    { label: "Useful Tips", key: "usefulTips", children: <UsefulTipsTab /> },
  ];

  const handleHomepageAction = (activeTab: string, subActiveTab: string) => {
    if (activeTab === "sliders") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/homepage/slider/add")}
        >
          Add Slider
        </Button>
      );
    } else if (activeTab === "spotlight" && subActiveTab !== "spotlightPage") {
      const spotlightRoutes: Record<string, string> = {
        spotlightCards: "/dedicated/passenger/homepage/spotlight/card/add",
        spotlightPage: "/dedicated/passenger/homepage/spotlight/page/add",
        highlight: "/dedicated/passenger/homepage/spotlight/highlight/add",
      };

      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate(spotlightRoutes[subActiveTab ?? "spotlightCards"])}
        >
          {subActiveTab === "spotlightCards"
            ? "Add Spotlight Card"
            : subActiveTab === "highlight"
              ? "Add Highlight"
              : ""}
        </Button>
      );
    } else if (activeTab === "youtube") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/homepage/youtube/add")}
        >
          Add YouTube Entry
        </Button>
      );
    } else if (subActiveTab === "travellerEssentialsList") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/homepage/travellerEssentialsList/add")}
        >
          Add Traveller Essential
        </Button>
      );
    } else if (activeTab === "usefulTips") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/homepage/usefulltips/add")}
        >
          Add Useful Tips
        </Button>
      );
    } else {
      return null;
    }
  };

  const airportTextMap: Record<string, string> = {
    sliders: "Airport Specific Content",
    spotlight: "Global/Non-Airport Specific Content",
    youtube: "Global/Non-Airport Specific Content",
    travellerEssentials: "Airport Specific Content",
    usefulTips: "Global/Non-Airport Specific Content",
  };

  const airportText = airportTextMap[activeTab || "sliders"];

  return (
    <ContentWrapper
      title="Homepage"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleHomepageAction(activeTab, subActiveTab)}
      airportText={airportText}
    >
      <Tabs
        activeKey={activeTab || "sliders"}
        items={items}
        onChange={(key) => {
          let targetUrl = `${window.location.pathname}?activeTab=${key}`;
          if (key === "spotlight") {
            targetUrl += "&subActiveTab=spotlightCards";
          } else if (key === "travellerEssentials") {
            targetUrl += "&subActiveTab=travellerEssentialsOverview";
          }
          navigate(targetUrl);
        }}
      />
    </ContentWrapper>
  );
};

export default HomepageManagement;
